import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import type {
  TComboboxListElement,
  TComboboxListProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { cn } from "@/ui/lib/utils";

export const ComboboxList = forwardRef<TComboboxListElement, TComboboxListProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive.List
      data-component="ComboboxList"
      ref={ref}
      className={cn(
        "max-h-72 overflow-y-auto overflow-x-hidden p-1",
        className,
      )}
      {...props}
    />
  ),
);

ComboboxList.displayName = CommandPrimitive.List.displayName;
